import _ from 'lodash';

export function DeepCopy(object) {
    let resultObject = {};
    for (let obj in object) {
        if (typeof (object[obj]) == "object") {
            if (!Array.isArray(object[obj])) {
                let x = {}
                x[obj] = DeepCopy(object[obj])
                Object.assign(resultObject, x);
            }else{
                let x = {}
                x[obj] = _.clone(object[obj])
                Object.assign(resultObject, x);
            }
        } else {
            let x = {};
            x[obj] = object[obj];
            Object.assign(resultObject, x);
        }
    }
    return resultObject;
}
